<nz-form-item class="sf-btns" style="width: 100%; text-align: center; padding-top: 20px">
  <div nz-col class="ant-form-item-control">
    <div class="ant-form-item-control-input">
      <div class="ant-form-item-control-input-content">
        <button nz-button type="button" [nzType]="'primary'" (click)="_submitForm()">保存</button>
        <button nz-button type="button" (click)="_resetForm()">重置</button>
      </div>
    </div>
  </div>
</nz-form-item>
